var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "ul",
    { staticClass: "igc-notice", style: { background: _vm.mColor(7) } },
    [
      _vm._l(_vm.noticeList, function(item, index) {
        return [
          index == 0
            ? _c(
                "li",
                {
                  key: item.iId,
                  on: {
                    click: function($event) {
                      return _vm.to(item.iId)
                    }
                  }
                },
                [
                  _c("div", { staticClass: "ig--info" }, [
                    _c(
                      "div",
                      {
                        staticClass: "ig--title",
                        style: { color: _vm.mColor(1) }
                      },
                      [_vm._v(_vm._s(item.sTitle))]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "ig--desc",
                        style: { color: _vm.mColor(3) }
                      },
                      [
                        _c(
                          "router-link",
                          {
                            staticClass: "ig--label",
                            style: { background: _vm.mColor(10) },
                            attrs: {
                              to: {
                                name: "notice",
                                query: {
                                  id: _vm.notice.id,
                                  name: _vm.notice.name
                                }
                              }
                            },
                            nativeOn: {
                              click: function($event) {
                                $event.stopPropagation()
                              }
                            }
                          },
                          [
                            _c("span", { style: { color: _vm.mColor(2.1) } }, [
                              _vm._v("公告")
                            ])
                          ]
                        ),
                        _c("span", [
                          _vm._v(
                            _vm._s(
                              _vm._f("mcFormatTime")(
                                _vm.noticeList[0].sIdxTime,
                                "M月D日"
                              )
                            )
                          )
                        ])
                      ],
                      1
                    )
                  ]),
                  _c("sui-image", {
                    attrs: { src: _vm.mImageView(item.sIMG, "/1/w/315/h/210") }
                  })
                ],
                1
              )
            : _vm._e(),
          index > 0
            ? _c(
                "li",
                {
                  key: item.iId,
                  staticClass: "ig--mini",
                  style: { background: _vm.mBackground(8.1, "top") },
                  on: {
                    click: function($event) {
                      return _vm.to(item.iId)
                    }
                  }
                },
                [
                  _c(
                    "div",
                    {
                      staticClass: "ig--title ig-style--ellipsis",
                      style: { color: _vm.mColor(1) }
                    },
                    [_vm._v(_vm._s(item.sTitle))]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "ig--time",
                      style: { color: _vm.mColor(3) }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm._f("mcFormatTime")(item.sIdxTime, "M月D日"))
                      )
                    ]
                  )
                ]
              )
            : _vm._e()
        ]
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }